<template>
    <div class="modal-dialog modal-xxl p-9">
        <div class="modal-content modal-rounded">
            <div class="modal-header bg-primary py-7 d-flex justify-content-between">
                <h2 class="text-white">{{$t('upload_image')}} </h2>
                <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" ::aria-label="$t('close')" ref="closeStockAccountUploadImageModal" @click="onCloseModal()">
                    <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                        </svg>
                    </span>
                </div>
            </div>
            <div class="modal-body scroll-y m-3" >
                <div class="stepper stepper-links d-flex flex-column" data-kt-stepper="true">
                    <form id="poliformAssetModal" @submit.prevent="" class="fv-plugins-bootstrap5 fv-plugins-framework" novalidate="novalidate">
                        <div class="current">
                            <div class="w-100">
                                 <div class="fv-row row">
                                    <div class="col-lg-12 mt-0"> 
                                        <div class="d-flex flex-row row">
                                            <div class="d-flex flex-column flex-row-auto col-lg-12"> 
                                                <h2 class="text-gray-800 mb-3 text-center justify-content-center">{{this.account.name}} {{ this.$t('image_upload') }}</h2>
                                                <div class="file-uploader-block">
                                                    <DxFileUploader
                                                        :accept="'image/*'"
                                                        :multiple="true"
                                                        :allowed-file-extensions="['.jpeg', '.gif', '.png', '.webp', '.svg', '.jpg']"
                                                        upload-url="/api/MediaLibrary/StockUpload"
                                                        upload-mode="useButtons"
                                                        selectButtonText="Select Image"
                                                        :upload-headers="getUploadHeaders()"
                                                        :on-uploaded="getAccountImageData"
                                                        :ref="'fileUploader'"
                                                        :activeStateEnabled="false"
                                                        :allowCanceling="false"
                                                        @valueChanged="e => files = e.value"
                                                    />
                                                </div> 
                                                <small class="note mb-5">
                                                    {{$t('allowed_file_extensions')}}
                                                    <span>{{$t('jpg_jpeg_gif_png')}}</span>.
                                                </small>
                                                <!-- <small class="note mb-5">
                                                    {{$t('dimensions_you_should_use')}}
                                                    <code>{{$t('1280x768_1024x768')}}</code>.
                                                </small> -->
                                                <div class="card table p-3"  v-if="imagePreviewList.length > 0" >
                                                    <table class="table">
                                                        <thead class="thead-dark">
                                                            <tr>
                                                            <th scope="col">{{$t('main')}}</th>
                                                            <th scope="col">{{$t('image')}}</th>
                                                            <th scope="col">{{$t('title')}}</th>
                                                            <th scope="col">{{$t('size')}}</th>
                                                            <th scope="col">{{$t('extension')}}</th>
                                                             <th scope="col">{{$t('delete')}}</th> 
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="image in imagePreviewList" :key="image">
                                                                <td> 
                                                                    <input type="checkbox"  class="form-check-input"  v-model="image.is_default" @change="onChangeDefaultImage(image)" >
                                                                </td>
                                                                <td>
                                                                    <img :src="image.url + '/' + image.company_folder + '/' + image.name" class="rounded shadow" width="100" height="100" alt="">
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <input type="text" :placeholder="$t('title')" class="form-control" v-model="image.title">
                                                                    </div>
                                                                </td>
                                                                <td class="text-muted">{{ image.size }}/kb</td>
                                                                <td class="text-muted">.{{ image.extension }}</td>
                                                                 <th ><i class="bi bi-trash fs-2 cursor-pointer" @click="removeImage(image)"></i></th>
                                                            </tr>    
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div class="col-lg-12 mt-5" v-if="this.imagePreviewList.length > 0" >
                            <div class="d-grid gap-2"> 
                                <button type="submit" :disabled="fileControl " class="btn btn-lg btn-block btn-success" @click="uploadImageAccount()" >
                                    <span class="svg-icon svg-icon-2" v-if="!fileControl">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                            <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                        </svg>
                                    </span>
                                    <span class="svg-icon svg-icon-2" v-else>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hourglass-split" viewBox="0 0 16 16">
                                        <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                                        </svg>
                                    </span>
                                    {{ fileControl ?   "Press the upload button" : "Save" }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="overlay-layer bg-dark bg-opacity-5" v-if="this.isUploadSaving == true">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden"> {{ $t('loading') }} </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
 import axios from "axios";
 import { DxFileUploader} from 'devextreme-vue/file-uploader';

export default {
    name: "AccountImageUpdate",
    props:{
        account : Object
    },
    data() {
        return {
            isUploadSaving:false,
            mainImageSelected:null,
            imagePreviewList: [], 
            files:[],
            folderId: null,
        };
    },
    components:{
        DxFileUploader,
    },
    computed: {
        fileControl() {
            return this.files.length > 0;
        }
	},
    methods: {
        getFolderId(){
            if(this.$refs.fileUploader) this.$refs.fileUploader.instance.reset();
            this.imagePreviewList = [];
            const parameters = { 
                session_id: this.$getUser().session_id,
                folder_name: 'account_images'
            }; 
            axios.post('/api/MediaLibrary/GetLogoFolder', parameters, {'Content-Type': 'application/json'})
            .then((response) => {
                this.folderId = response.data;
                this.getAccountImageData();
            }) 
            .catch((error) => {
                console.error(error);
                this.Progress.finish();
            });   
        },
        getAccountImageData(){
            const params = {
                session_id: this.$getUser().session_id,
                account_id : this.account.id
            }
            axios.post('/api/MediaLibrary/GetAccountImages',params,{'Content-Type' : 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                    this.imagePreviewList = response.data;
                    if (this.imagePreviewList.length > 0) { this.imagePreviewList[0].is_default = true; }
                    if(this.$refs.fileUploader) this.$refs.fileUploader.instance.reset();
                }
            }).catch((error)=>{
                console.error(error)
            });
        }, 
        uploadImageAccount(){
            const titles = this.imagePreviewList.map(image => ({
                id: image.id,
                title: image.title,
                is_default: image.is_default ? 1 : 0
            }));
            const params = {
                session_id : this.$getUser().session_id,
                titles: titles,
            }
            axios.post('/api/MediaLibrary/UpdateStockAccountImageTitle',params,{'Conent-Type':'application/json'})
            .then((response)=>{
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                    if(this.$refs.fileUploader) this.$refs.fileUploader.instance.reset();
                    this.$refs.closeStockAccountUploadImageModal.click();
                    this.$emit('refreshImageData'); 
                }
                
            }).catch((error)=>{
                console.error(error);
            })
        },
        getUploadHeaders(){     
            return { 
                sid: this.$getUser().session_id,
                cid: this.$getUser().company_account_id,
                ctd: this.$getUser().controller_account_id,
                stkid: this.account.id,
                fid: this.folderId,
                url: window.location.origin + '/assets/uploads/account_images' 
            };
        },
        onChangeDefaultImage(item){
            this.imagePreviewList.forEach((value) => {  
                if (item.id !== value.id) { 
                    value.is_default = false;
                }
            });
        },
        removeImage(item){
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_delete_this_image'),
                confirmButtonColor: "#E53935",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('yes'),
                icon: 'warning'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    const params = {
                        session_id: this.$getUser().session_id,
                        id: item.id,
                        name: item.name,
                        account_id:this.account.id
                    };
                    axios.post("/api/MediaLibrary/DeleteAccountImage",params,{'Content-Type':'application/json'})
                    .then((response)=> {                        
                        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                            this.getAccountImageData();
                        }
                    }).catch((error)=>{
                        console.error(error);
                    })
                }
            });
        },
        onCloseModal() {
            this.$emit('refreshImageData');
        }
    },
    created() {
        this.getFolderId();
    }
};
</script>